/* v8 ignore start */
export { default } from './ComplexWizard';
export { default as reducer } from './ComplexWizard.slice';
export { default as sagas } from './ComplexWizard.sagas';

import * as actions from './ComplexWizard.slice';
export { actions };
